

export const getColor = ({d, i, top, sentiment, primary, fromd3}) => {
  const topColors = [
    'rgb(31, 119, 180)',
    'rgb(255, 127, 14)',
    'rgb(44, 160, 44)',
    'rgb(214, 39, 40)',
    'rgb(148, 103, 189)',
    'rgb(140, 86, 75)',
    'rgb(227, 119, 194)',
    'rgb(127, 127, 127)',
    'rgb(188, 189, 34)',
    'rgb(23, 190, 207)'
  ];

  const sentimentColors = {
    Positive: 'rgb(44, 160, 44)',
    Negative: 'rgb(214, 39, 40)',
    Void: 'rgb(127, 127, 127)'
  };

  if (top) {
    return topColors[i];
  }
  if (sentiment) {
    const value = fromd3 ? d.data.sentiment : d.sentiment;
    return sentimentColors[value];
  }
  if (primary) {
    const value = fromd3 ? d.data.primary : d.primary;
    switch (value) {
      case "Love":
        return "rgb(191, 63, 63)";
      case "Joy":
        return "rgb(191, 159, 63)";
      case "Trust":
        return "rgb(128, 191, 63)";
      case "Surprise":
        return "rgb(63, 191, 96)";
      case "Sadness":
        return "rgb(63, 191, 191)";
      case "Fear":
        return "rgb(63, 95, 191)";
      case "Anger":
        return "rgb(127, 63, 191)";
      case "Disgust":
        return "rgb(191, 63, 159)";
      case "Void":
        return "rgb(127, 127, 127)";
      case "Body Sense":
        return "rgb(159, 95, 95)";
      default:
        return "grey";
    }
  }
};


// WEBPACK FOOTER //
// ./src/utilities/getColor.js